import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    appMenu: {
        width: `27.5px !important`,
        height: `27.5px !important`,
        color: `${theme.palette.primary.main} !important`,
    },
    mainWrapper: {
        display: "flex",
        flexWrap: "wrap",
        gap: "24px",
        maxWidth: 327,
        maxHeight: 470,
        padding: "24px",
        backgroundColor: theme.palette.primary.main,
        justifyContent: "center",
        overflowY: "auto",
    },
    appMenuItem: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        width: 72,
        height: 72,
        padding: "8px",
        borderRadius: "4px",
        backgroundColor: theme.palette.info.main,
        color: theme.palette.primary.main,
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.palette.info.lighter,
            color: theme.palette.primary.main,
        },
    },
    appMenuItemText: {
        fontFamily: "Open Sans !important",
        fontSize: "12px !important",
        fontWeight: "700 !important",
    },
    appMenuIcon: {
        margin: "0 !important",
        transform: "scale(1.3)",
        "& > g > path": {
            stroke: theme.palette.primary.main,
            fill: theme.palette.primary.main,
        },
    },
}));
